import { StorageProvider, StorageBucket } from '../../modules/thumbnailGenerationService/types';
import { BackendClient } from '@/infrastructure/clients/BackendClient';

export class SupabaseStorageAdapter implements StorageProvider {
  constructor() {}

  from(bucket: string): StorageBucket {
    return new BackendStorageBucket(bucket);
  }
}

class BackendStorageBucket implements StorageBucket {
  constructor(private readonly bucket: string) {}

  async list(path: string): Promise<{ data: any[] | null; error: any }> {
    return await BackendClient.storage.from(this.bucket).list(path);
  }

  getPublicUrl(path: string): { data: { publicUrl: string } } {
    return BackendClient.storage.from(this.bucket).getPublicUrl(path);
  }
} 